export default __webpack_public_path__ + "static/media/user1.3fd98534.jpg";